<template>
    <transition name="fade">
      <div class="back-modal">
        <div
          v-show="open"
          class="login-modal"
        >
          <transition name="drop-in">
            <div
              v-show="open"
              class="login-modal-inner"
            >
              <div class="login-modal-content">
                <div v-if="step === 0">
                    <div class="login-modal-header">
                        <h3 class="login-modal-header-title">
                        Вход в личный кабинет CIC.KZ
                        </h3>
                        <p class="login-modal-header-desc">
                        Выберите способ входа
                        </p>
                    </div>
                    <div class="login-modal-body">
                        <div class="login-modal-body-item" @click="changeStep(1)">
													<p class="login-modal-body-item-title">Вход через ЭЦП</p>
													<img src="../assets/images/login_esp.svg" alt="">
													<p class="login-modal-body-item-recom">Рекомендуется</p>
                        </div>
                        <div class="login-modal-body-item" @click="changeStep(2)">
													<p class="login-modal-body-item-title">Вход по ИИН и паролю</p>
													<img src="../assets/images/login_bin.svg" alt="">
													<p class="login-modal-body-item-desc">(альтернативный способ)</p>
                        </div>
                    </div>
                </div>
                <div v-if="step === 1">
                  <button
                        v-if="step !== 0"
                        type="button"
                        class="back"
                        @click="changeStep(0)"
                      >
                          < Назад
                    </button>
                    <div class="login-modal-header">
                        <h3 class="login-modal-header-title">
                            Авторизация через ЭЦП
                        </h3>
                    </div>
                    <div class="login-modal-body">
                        <div class="login-modal-body-form">
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isEspError}">
                                Выберите сертификат
                            </p>
                            <div class="login-modal-body-form-field-file" :class="{'disabledField' : selectedFile}">
                                <Field
                                    type="file"
                                    name="esp_file"
                                    class="login-modal-body-form-field-file"
                                    @change="handleFileChange" 
                                    @click="IsRemove = false"
                                    :disabled="selectedFile"
                                />
                                Выбрать сертификат
                            </div>
                            <div v-if="selectedFile" class="selectedFile">
                              <p v-html="selectedFile.name"></p>
                              <p class="remove-file" @click="removeESPFile">X</p>
                            </div>
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isPasswordError}">
                                Введите пароль от сертификата
                            </p>
                            <div class="password-field">
                                <Field
                                    v-model="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    name="password"
                                    class="login-modal-body-form-field"
                                    @update:modelValue="handlePasswordChange"
                                    @click="IsRemove = false"
                                />
                                <span class="password-field-toggle" @click="showPassword = !showPassword">
                                    <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                    <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                </span>
                            </div>
                            <button @click="submitForm('esp')">Войти</button>
                        </div>
                    </div>
                </div>
                <div v-if="step === 2">
                   <button
                        v-if="step !== 0"
                        type="button"
                        class="back"
                        @click="changeStep(0)"
                      >
                          < Назад
                    </button>
                    <div class="login-modal-header">
                        <h3 class="login-modal-header-title">
                            Авторизация по ИИН и паролю 
                        </h3>
                    </div>
                    <div class="login-modal-body">
                        <div class="login-modal-body-form">
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isIinError}">
                                Введите ИИН
                            </p>
                            <Field
                                v-model="iin"
                                name="iin"
                                class="login-modal-body-form-field"
                                @update:modelValue="handleIinChange"
                            />
                        
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isPasswordError}">
                                Введите пароль
                            </p>
                            <div class="password-field">
                                <Field
                                    v-model="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    name="password"
                                    class="login-modal-body-form-field"
                                    @update:modelValue="handlePasswordChange"
                                    @click="IsRemove = false"
                                />
                                <span class="password-field-toggle" @click="showPassword = !showPassword">
                                    <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                    <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                </span>
                            </div>
                            <a @click="changeStep(4)" class="forget_password">Забыли пароль?</a>
                            <button @click="submitForm('iin')">Войти</button>
                          </div>
                    </div>
                </div>
                <div v-if="step === 3">
                    <div class="login-modal-header">
                        <h3 class="login-modal-header-title">
                            Двухфакторная авторизация
                        </h3>
                    </div>
                    <div class="login-modal-body">
                      <button
                        v-if="step !== 0"
                        type="button"
                        class="back"
                        @click="changeStep(2)"
                      >
                          < Назад
                      </button>
                        <div class="login-modal-body-form">
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isIinError}">
                                Введите код, отправленный вам на почту
                            </p>
                            <div class="code-inputs">
                              <input
                                v-for="(digit, index) in code"
                                :key="index"
                                v-model="code[index]"
                                ref="inputs"
                                maxlength="1"
                                @input="onInput(index)"
                                @keydown.backspace.prevent="onBackspace(index)"
                                @paste="onPaste($event)"
                                class="digit-input"
                              />
                            </div>
                            <button class="resend_btn" @click="resendCode">Отправить код повторно</button>
                            <button @click="submitCode">Войти</button>
                          </div>
                    </div>
                </div>
                <div v-if="step === 4">
                  <div class="login-modal-header">
                    <h3 class="login-modal-header-title">
                      Забыли пароль?
                    </h3>
                  </div>
                  <div class="login-modal-body">
                    <button
                      v-if="step !== 0"
                      type="button"
                      class="back"
                      @click="changeStep(2)"
                    >
                      < Назад
                     </button>
                     <div class="login-modal-body-form">
                        <p class="login-modal-body-form-field-label" :class="{'field-error' : isIinError}">
                          Введите иин
                        </p>
                        <Field
                            v-model="iin"
                            name="iin"
                            class="login-modal-body-form-field"
                            @update:modelValue="handleIinChange"
                        />
                          <button @click="resetPassword">Отправить код</button>
                      </div>
                  </div>
                </div>
                <div v-if="step === 5">
                    <div class="login-modal-header">
                        <h3 class="login-modal-header-title">
                            Изменить пароль
                        </h3>
                    </div>
                    <div class="login-modal-body">
                      <button
                          v-if="step !== 0"
                          type="button"
                          class="back"
                          @click="changeStep(2)"
                      >
                          < Назад
                      </button>
                      <div class="login-modal-body-form">
                          <p class="login-modal-body-form-field-label">
                              Введите код, отправленный вам на почту
                          </p>
                          <div class="code-inputs">
                              <input
                                  v-for="(digit, index) in code"
                                  :key="index"
                                  v-model="code[index]"
                                  ref="inputs"
                                  maxlength="1"
                                  @input="onInput(index)"
                                  @keydown.backspace.prevent="onBackspace(index)"
                                  @paste="onPaste($event)"
                                  class="digit-input"
                                />
                            </div>
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isPasswordError}">
                                Введите пароль
                            </p>
                            <div class="password-field">
                                <Field
                                    v-model="password"
                                    name="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    class="login-modal-body-form-field"
                                    @update:modelValue="handlePasswordChange"
                                />
                                <span class="password-field-toggle" @click="showPassword = !showPassword">
                                    <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                    <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                </span>
                            </div>
                            <p class="login-modal-body-form-field-label" :class="{'field-error' : isPasswordConfirmError}">
                                Потвердите пароль
                            </p>
                            <div class="password-field">
                                <Field
                                    v-model="password_confirmation"
                                    name="password_confirmation"
                                    class="login-modal-body-form-field"
                                    :type="showPasswordConfirmation ? 'text' : 'password'"
                                    @update:modelValue="handlePasswordConfirmationChange"
                                />
                                <span class="password-field-toggle" @click="showPasswordConfirmation = !showPasswordConfirmation">
                                    <svg v-if="!showPasswordConfirmation" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                    <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.06M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                </span>
                            </div>
                             <button @click="changePassword">Сохранить</button>
                          </div>
                        </div>
                    </div>
                <button
                  type="button"
                  class="close"
                  @click="close"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { onMounted, onUnmounted } from "vue";
  import { Field, Form, ErrorMessage } from "vee-validate";
  import { useToast } from 'vue-toastification'
  import { JSEncrypt } from 'jsencrypt'
  import axios from "axios";
  import store from "@/store";
  import router from "@/router";

  const toaster = useToast();

  export default {
    components: {  Field, Form, ErrorMessage },
    props: {
      open: {
        type: Boolean,
        required: true,
      },
    },
    data() {
        return {
            step: 0,
            selectedFile: null,
            password: null,
            isEspError: false,
            isPasswordError: false,
            publicKey: null,
            iin: null,
            isTwoFa: false,
            email: null,
            isIinError: false,
            password_confirmation: null,
            isPasswordConfirmError: false,
            code: ['', '', '', '', '', ''],
            showPassword: false,
            showPasswordConfirmation: false
        };
    },
    emits: ['close'],
    setup(_, { emit }) {
      const close = () => {
     
        emit("close");
      };
      const handleKeyup = (event) => {
        if (event.keyCode === 27) {
          close();
        }
      };
  
      // onMounted(() => document.addEventListener("keyup", handleKeyup));
      onUnmounted(() => document.removeEventListener("keyup", handleKeyup));
      return { close };
    },
    watch: {
        open: function () {
          if (this.open) {
            document.documentElement.style.overflow = "hidden";
            return;
          }
          this.iin = null
          this.password = null
          this.selectedFile = null
          this.isEspError = false
          this.isPasswordError = false
          this.isIinError = false
          this.step = 0
          this.email = null
          this.showPassword = false
          this.showPasswordConfirmation = false
          document.documentElement.style.overflow = "auto";
        },
      },
    methods: {
        changeStep: function(stepNum){
            this.step = stepNum
        },
        removeESPFile(){
          this.selectedFile = null
          this.isEspError = true
        },
        handleFileChange(e) {
          this.selectedFile = e.target.files[0]
          this.isEspError = false
        },
        handlePasswordChange(e) {
          this.password = e
        },
        handleIinChange(e){
          this.iin = e
        },
        handleEmailChange(e){
          this.email = e
        },
        handlePasswordConfirmationChange(e){
          this.password_confirmation = e
        },
        resendCode(){
          try {
            axios.post(`/V1/auth/resend-2fa-code`, {iin: this.iin}).then(response => {
              toaster.success("Код повторно отправлен на почту", {
                position: "top-right"
              })
            }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                message = error.response.data.message;
              } else {
                message = String(error);
              }
                toaster.error(message, {
                  position: "top-right"
                })
              })
          } catch (error) {
            console.error('Ошибка повторной отправки кода:', error)
          }
        },
        onInput(index) {
          const input = this.$refs.inputs[index];
          const value = input.value;
          if (value.length === 1 && index < this.code.length - 1) {
            this.$refs.inputs[index + 1].focus();
          }
          this.code[index] = value;
        },
        onBackspace(index) {
          if (this.code[index] === '' && index > 0) {
            this.$refs.inputs[index - 1].focus();
          }
          this.code[index] = ''
        },
        onPaste(event) {
          event.preventDefault();
          const pasted = (event.clipboardData || window.clipboardData).getData('text');
          const digits = pasted.replace(/\D/g, '').split('').slice(0, this.code.length);
          if (!digits.length) return;
          digits.forEach((digit, i) => {
            this.code[i] = digit;
          });
          for (let i = digits.length; i < this.code.length; i++) {
            this.code[i] = '';
          }
          this.$nextTick(() => {
            const nextIndex = Math.min(digits.length, this.code.length - 1);
            const target = this.$refs.inputs[nextIndex];
            if (target) target.focus();
          });
        },
        submitCode() {
          const fullCode = this.code.join('');
          try {
            axios.post(`/V1/auth/verify-2fa-code`, {iin: this.iin, code: Number(fullCode)}).then(response => {
              store.dispatch('auth/set_user', {token: response.data.data.access_token, user: response.data.data.user})
              this.code = ['', '', '', '', '', '']
              this.close()
              router.push('/profile')
            }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                message = error.response.data.message;
              } else {
                message = String(error);
              }
                toaster.error(message, {
                  position: "top-right"
                })
              })
          } catch (error) {
            console.error('Ошибка повторной отправки кода:', error)
          }
        },
        async submitForm(type){
          if(type === 'esp'){
            if(!this.selectedFile || !this.password){
              if(!this.selectedFile){
                this.isEspError = true
              }
              if(!this.password){
                this.isPasswordError = true
              }
              return null
            }else{
              try {
                const res = await fetch('/publicKey.pem')
                const publicKey = await res.text()
                const encryptor = new JSEncrypt()
                encryptor.setPublicKey(publicKey)
                const formData = new FormData();
                formData.append('ecp', this.selectedFile);
                formData.append('password', encryptor.encrypt(this.password));
                const data = await store.dispatch('auth/login', {method: 'ecp', data: formData})
                if(!data.success){
                  let message;
                  if (axios.isAxiosError(data.error) && data.error.response) {
                    message = data.error.response.data.message;
                  } else {
                    message = String(data.error);
                  }
                  if(data.error.response.data.data.requires_2fa){
                    this.step = 3
                  }
                  toaster.error(message, {
                    position: "top-right"
                  })
                }else{
                  this.close()
                  router.push('/profile')
                }
               
              } catch (error) {
                console.error('Ошибка загрузки ключа:', error)
              }
            }
          }else{
            if(!this.iin || !this.password){
              if(!this.iin){
                this.isIinError = true
              }
              if(!this.password){
                this.isPasswordError = true
              }
              return null
            }else{
              try {
                const formData = new FormData();
                formData.append('iin', this.iin);
                formData.append('password', this.password);
                const data = await store.dispatch('auth/login', {method: 'iin', data: formData})
                if(!data.success){
                  let message;
                  if (axios.isAxiosError(data.error) && data.error.response) {
                    message = data.error.response.data.message;
                  } else {
                    message = String(data.error);
                  }
                  if(data.error.response.data.data.requires_2fa){
                    this.step = 3
                  }
                  toaster.error(message, {
                    position: "top-right"
                  })
                }else{
                    this.close()
                    router.push('/profile')
                }
              } catch (error) {
                console.error('Ошибка загрузки ключа:', error)
              }
            }
          }
        },
        resetPassword(){
          try {
            axios.post(`/V1/auth/forgot-password`, {iin: this.iin}).then(response => {
              toaster.success("Код отправлен вам на почту!", {
                  position: "top-right"
                })
                setTimeout(() => {
                  this.step = 5
                }, 600)
            }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                message = error.response.data.message;
              } else {
                message = String(error);
              }
                toaster.error(message, {
                  position: "top-right"
                })
              })
          } catch (error) {
            console.error('Ошибка повторной отправки кода:', error)
          }
        },
        changePassword(){
          try {
            const fullCode = this.code.join('');
            axios.post(`/V1/auth/reset-password`, {code: fullCode, iin: this.iin, password: this.password, password_confirmation: this.password_confirmation }).then(response => {
              toaster.success("Пароль успешно изменен!", {
                  position: "top-right"
                })
                setTimeout(() => {
                  this.iin = null
                  this.password = null
                  this.code = null
                  this.step = 0
                }, 1000)
            }).catch(error => {
              let message;
              if (axios.isAxiosError(error) && error.response) {
                message = error.response.data.message;
              } else {
                message = String(error);
              }
                toaster.error(message, {
                  position: "top-right"
                })
              })
          } catch (error) {
            console.error('Ошибка повторной отправки кода:', error)
          }
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @mixin mobile {
    @media (min-width: 320px) and (max-width: 425px) {
      @content;
    }
  }
  @mixin tablet {
    @media (min-width: 425px) and (max-width: 768px) {
      @content;
    }
  }
  @mixin tablet-1024 {
    @media (min-width: 768px) and (max-width: 1024px) {
      @content;
    }
  }
  
  *,
  ::before,
  ::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .open {
    background-color: red;
  }
  .forget_password{
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: underline !important;
    margin-top: 10px;
    color: #007BFF;
  }
  .field-error{
    color: red !important;
  }
  .disabledField{
    background: #838484 !important;
  }
  .back{
    position: absolute;
    top: 15px;
    left: 30px;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    font-size: 18px;
    cursor: pointer;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    padding-right: 5px;
    background: #ffff;
    border-radius: 15px;
    &::after {
      display: inline-block;
      content: "x";
      margin-top: 15px;
      margin-right: 15px;
    }
  }
  .selectedFile{
    display: flex;
    justify-content: space-between;
    align-items: center;
    p{
      word-break: break-word;
    }
    .remove-file{
      color: red;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .password-field {
    position: relative;
    width: 100%;
    .login-modal-body-form-field {
      padding-right: 45px;
    }
    &-toggle {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #838484;
      transition: color 0.2s;
      &:hover {
        color: #373737;
      }
    }
  }
  .code-inputs {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .digit-input {
    width: 40px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  .resend_btn{
    border: none !important;
    background: transparent !important;
    cursor: pointer;
    padding: 0;
    color: black !important;
		&:before {
			content: none !important;
		}
		&:hover {
			text-decoration: underline;
		}
  }
  .login-modal{
    &-header{
        &-title{
            font-size: 24px;
            text-align: center;
            width: 100%;
            margin-top: 30px;
        }
        &-desc{
            text-align: center;
            font-size: 22px;
        }
    }
    &-body{
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        gap: 20px;
				@media (max-width: 550px) {
					flex-direction: column;
				}
        &-item{
            padding: 15px;
            box-sizing: border-box;
            background: #F7F7F6;
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 9px;
            cursor: pointer;
						border: 2px solid transparent;
						transition: .2s border;
						&:hover {
							border: 2px solid #D8D8D8;
						}
						@media (max-width: 550px) {
							width: 100%;
						}
            &-title{
                text-align: center;
            }
            &-recom{
                font-size: 14px;
                text-align: center;
                background: #37A979;
                color: #fff;
                padding: 10px 20px;
                border-radius: 9px;
            }
            &-desc{
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
            }
            
            img{
                margin: 10px 0;
            }
        }
        &-form{
            // margin-top: 15px;
            width: 100%;
            &-field{
                width: 100%;
                height: 55px;
                padding: 15px;
                &-label{
                    color: #373737;
                    font-size: 16px;
                    margin-bottom: 10px;
                    margin-top: 15px;
                }
                &-file{
                    width: 100%;
                    padding: 15px 0;
                    border-radius: 8px;
                    background: #007BFF;
                    position: relative;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 15px;
                    cursor: pointer;
										transition: background 0.2s;
										&:hover {
											background: #0059B9;
										}
                    input{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        opacity: 0;
                    }
                }
            }
            button{
                width: 100%;
                padding: 15px 0;
                border-radius: 8px;
                background: #007BFF;
                margin-top: 15px;
                color: #fff;
                border: none;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                z-index: 1;
                &::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    z-index: -1;
                    background: linear-gradient(90deg, #F5010A 0%, #1521E9 100%);
                    opacity: 0;
                    transition: opacity 0.3s;
                }

								&:hover::before {
									opacity: 1;
								}
            }
        }
    }
    }
  .back-modal {
  }
  .login-modal {
    // overflow: hidden;
    // overflow-y: scroll;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    padding-top: 10%;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1000 !important;
    // background: rgba(0, 0, 0, 0.1);
    &-inner {
      width: clamp(250px, 60%, 500px);
      margin: 10px auto;
      filter: drop-shadow(0px 4px 30px rgba(0, 0, 0, 0.13));
      z-index: 10000000 !important;
    }
    &-content {
      position: relative;
      background-color: #fff;
      background-clip: padding-box;
      border-radius: 15px;
      padding: 25px;
    }
    @include mobile() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
    @include tablet() {
      &-inner {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
  
  
  //animation --->
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .drop-in-enter-active,
  .drop-in-leave-active {
    transition: all 0.3s ease-out;
  }
  .drop-in-enter-from,
  .drop-in-leave-to {
    opacity: 0;
    transform: translateY(-50px);
  }
  </style>
  